module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/QRlogoBlack.0e6f687417b3c07c9870df6ab2dab5db.svg";